import { keyframes } from '@emotion/core'
import { NavBottomPadding, NavH } from '@styles/base.style'
import styled from '@themes/theme'

export const GuideWrap = styled.div`
  position: relative;
  padding: 0 0 ${NavBottomPadding};
  background: ${props => props.theme.color.mainBg};
  .guide-section {
    position: relative;
    height: auto;
    margin-top: 30px;
    &--target {
      position: absolute;
      top: -100px;
      left: 0;
    }
    img {
      pointer-events: none;
      &.pc-img {
        image-rendering: -webkit-optimize-contrast; /* 해당 속성이 iOS에서 픽셀화 되어 보임 */
      }
    }
  }
`
export const GuideNavWrap = styled.div`
  z-index: 2;
  position: sticky;
  top: 74px;
  background: ${props => props.theme.color.mainBg};
  .guide-nav {
    display: flex;
    flex: 1;
    justify-content: space-around;
    &::before {
      content:'';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: ${props => props.theme.color.btn};
      opacity: .5;
    }
    li {
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 40px;
    }
  }
`
export const GuideNavBtn = styled.span`
  color: ${props => props.theme.color.themeTxt};
  opacity: .3;
  &.active {
    opacity: 1;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: ${props => props.theme.color.underover};
    }
  }
`
export const GaugeHideAni = keyframes`
  0%{
    height: 48px;
    opacity: 1;
  }
  10% {
    opacity: 0;
  }
  100% {
    top: 48px;
    height: 0;
    overflow: hidden;
    opacity: 0;
  }
`
export const GaugeAni = keyframes`
  0%{
    width: 0%;
  }
  100% {
    width: 100%;
  }
`

export const CountAniWrap = styled.div`
  position: fixed;
  bottom: ${NavH};
  left: 0;
  width: 100%;
  height: 48px;
  /* overflow: hidden; */
  .gauge {
    position: relative;
    width: 100%;
    height: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${GaugeHideAni} .1s ease-out 1 forwards;
    animation-delay: 15s;
    overflow: hidden;
    &--bar {
      position: absolute;
      bottom:0;
      left: 0;
      width: 100%;
      height: 40px;
      background: ${props => props.theme.color.mainBg};
      &--fill {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: inherit;
        background: ${props => props.theme.color.primaryBg};
        animation: ${GaugeAni} 15s linear 1 forwards;
        &--gif {
          z-index: 1;
          position: absolute;
          bottom: 0;
          right: -35px;
          width: 50px;
          height: auto;
        }
      }
    }
    &--count {
      position: relative;
      top: 4px;
      &--num {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        margin-right: 4px;
        color: ${props => props.theme.color.mainBg};
        background: ${props => props.theme.color.themeTxt};
        border-radius: 50%;
      }
      &--txt {
        opacity: .75;
        color: ${props => props.theme.color.themeTxt};
      }
    }
  }
`

export const TipListWrap = styled.div`
  padding: 20px 18px ${NavBottomPadding};
  .tip-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 9px;
    background: ${props => props.theme.color.mainColor};
    border-radius: 6px;
    overflow: hidden;
    img {
      width: auto;
      max-width: 100%;
      height: auto;
    }
  }
  .am-list-view-scrollview {
    width: 100%;
  }
  &.pc-tip-list-wrap {
    height: 100%;
    .am-list-view-scrollview {
      height: 100%;
      overflow: auto;
      .am-list {
        width: 100%;
      }
    }
  }
`
